__turbopack_context__.v({
  "subtitleLink": "scheduleYourCall-module-scss-module__i-wyhW__subtitleLink",
});
